import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Select from 'react-select'
import { Dropdown } from 'react-bootstrap'
import DatePicker from 'react-datepicker'

import { GET, httpOk } from 'helpers/api'
import { chequeDates, formatDate, getCurrentChequeDate } from 'helpers/helpers'
import XReport from 'components/XReport'

function ZReport() {
	const { t } = useTranslation()
	const date = new Date()

	const [xReport, setXReport] = useState({
		show: false,
		products: {},
		payment_types: [],
		opened_shift: {},
	})

	const initialFilter = {
		start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
		end_date: formatDate(new Date(), 'yyyy-MM-dd'),
		pos_id: null,
		search: ''
	}
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(true)
	const [filterData, setFilterData] = useState({ ...initialFilter })

	function resetFilter() {
		setFilterData({ ...initialFilter })
	}

	async function checkFilter() {
		let hasFilter = false;
		for (const key in filterData) {
			if (filterData[key] !== initialFilter[key]) {
				hasFilter = true;
				break;
			}
		}
		setFilterDataExist(hasFilter);
	}

	async function selectChequeDates(option) {
		const result = getCurrentChequeDate(option.id)
		setFilterData({ ...filterData, ...result, 'dateType': option.id })
	}

	async function getData() {
		checkFilter()

		const response = await GET("/report/z-report", filterData, { loader: true })
		if (httpOk(response)) {
			setXReport(response.data)
			if (dropdownIsOpen) setDropdownIsOpen(false)
		}
	}

	useEffect(() => {
		getData()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('z_report')}
				</h4>
			</div>

			<div className="card">
				<div className="card-body" style={{ minHeight: '85vh' }}>
					<div className="d-flex justify-content-between mb-3">
						<div className="d-flex gap-2">
							<div>
								<Dropdown onToggle={() => setDropdownIsOpen(!dropdownIsOpen)} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-4">
												<label>{t('period')}</label>
												<Select
													options={chequeDates}
													value={chequeDates.find(option => option.id === filterData.dateType) || ''}
													onChange={(option) => selectChequeDates(option)}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>

											<div className="form-group col-md-4">
												<label className="invisible">{t('period')}</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.start_date ? new Date(filterData.start_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'start_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
											<div className="form-group col-md-4">
												<label className="invisible">.</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.end_date ? new Date(filterData.end_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'end_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
													<button className="btn btn-primary" onClick={() => getData()}>{t('apply')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<span>|</span>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<XReport xReport={xReport} />
				</div>
			</div>
		</>
	)
}

export default ZReport